import React, { useEffect, useState } from 'react';
import './CookieBanner.css';
import CookieIcon from '../../assets/CookieBanner.svg';

const COOKIE_KEY = 'cookiesAccepted';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-wrapper">
      <div className="cookie-card">
        <div className="cookie-header">
          <div className="cookie-icon">
            <img src={CookieIcon} alt="cookies" />
          </div>
          <div className="cookie-title">
            Мы используем файлы <span style={{fontWeight: 700}}>Cookies</span> <span style={{fontWeight: 700}}>и Яндекс.Метрика</span>
          </div>
        </div>

        <div className="cookie-text">
          Продолжая использование сайта, вы соглашаетесь с их применением в соответствии с{' '}
          <a href="/privacy-policy.pdf" target="_blank" rel="noreferrer">
            Политикой использования cookies и Яндекс.Метрика
          </a>
        </div>

        <button className="cookie-btn" onClick={handleAccept}>
          Принять и закрыть
        </button>
      </div>
    </div>
  );
};
